export default function tabs() {

	let tabsContainers = [...document.querySelectorAll('.tabs-container')];
	let tabSelector = [...document.querySelectorAll('.tab-selectors > button')];
	let optionSelector = [...document.querySelectorAll('.slider-select > option')];
	let dropdownSelector = [...document.querySelectorAll('.slider-select')];
	let tabContent = [...document.querySelectorAll('.panels-wrapper > div')];
	let largeRandNumber = Math.floor((Math.random() * 1000) + 1000);

	tabSelector.forEach(function (tabSelector) {
		tabSelector.addEventListener('click', onTabSelectorClick);
	});

	dropdownSelector.forEach(function (dropdownSelector) {
		dropdownSelector.addEventListener('change', onSelectChange);
	});

	tabsContainers.forEach(function (elem, indexAccessibleTabContainer) {
		elem.setAttribute('data-id', indexAccessibleTabContainer);

		tabSelector.forEach(function (singleTabSelector, i) {

			let tabSelectorId = 'tab-selector-' + largeRandNumber + '_' + i + '_' + indexAccessibleTabContainer;
			let tabOptionId = 'tab-option-' + largeRandNumber + '_' + i + '_' + indexAccessibleTabContainer;
			let tabContentId = 'tab-content-' + largeRandNumber + '_' + i + '_' + indexAccessibleTabContainer;

			singleTabSelector.setAttribute('data-id', i);
			singleTabSelector.setAttribute('id', tabSelectorId);
			singleTabSelector.setAttribute('aria-controls', tabContentId);

			optionSelector[i].setAttribute('data-id', i);
			optionSelector[i].setAttribute('id', tabOptionId);
			optionSelector[i].setAttribute('aria-controls', tabContentId);
			optionSelector[i].setAttribute('value', i);

			tabContent[i].setAttribute('data-id', i);
			tabContent[i].setAttribute('tabindex', 0);
			tabContent[i].setAttribute('role', 'tabpanel');
			tabContent[i].setAttribute('id', tabContentId);
			tabContent[i].setAttribute('aria-labeledby', tabSelectorId);

			if (i === 0) {
				singleTabSelector.setAttribute('aria-pressed', 'true');
			} else {
				singleTabSelector.setAttribute('aria-pressed', 'false');
				singleTabSelector.setAttribute('tabindex', -1);
			}
		});
	});


	function onTabSelectorClick(e) {

		let tabSelectorSelected = e.target;
		let tabsContainerSelected = tabSelectorSelected.closest('.tabs-container');
		let tabSelectorsSelectedFromTabs = [...tabsContainerSelected.querySelectorAll('.tab-selectors > button')];
		let tabContentsSelectedFromContainer = [...tabsContainerSelected.querySelectorAll('.panels-wrapper > div')];
		let dropdownSelectorSelectedFromTabs = [...tabsContainerSelected.querySelector('.slider-select')];

		if (!tabSelectorSelected.classList.contains('active-tab-selector')) {
			tabSelectorsSelectedFromTabs.forEach(function (singleTabSelected, i) {
				if (tabSelectorSelected.getAttribute('data-id') === tabContentsSelectedFromContainer[i].getAttribute('data-id')) {
					activateTab(singleTabSelected);
					tabContentsSelectedFromContainer[i].classList.add('tab-content-active');
					dropdownSelectorSelectedFromTabs.value = tabSelectorSelected.getAttribute('data-id'); // update dropdown
				} else {
					deactivateTab(singleTabSelected);
					tabContentsSelectedFromContainer[i].classList.remove('tab-content-active');
				}

			});
		}

	}

	function onSelectChange(e) {

		let dropdownSelected = e.target;
		let tabsContainerSelected = dropdownSelected.closest('.tabs-container');
		let tabSelectorsSelectedFromTabs = [...tabsContainerSelected.querySelectorAll('.tab-selectors > button')];
		let tabContentsSelectedFromContainer = [...tabsContainerSelected.querySelectorAll('.panels-wrapper > div')];
		// get selected option
		let selectedOption = dropdownSelected.options[dropdownSelected.selectedIndex];

		tabSelectorsSelectedFromTabs.forEach(function (singleTabSelected, i) {
			if (selectedOption.getAttribute('data-id') === tabContentsSelectedFromContainer[i].getAttribute('data-id')) {
				activateTab(singleTabSelected);
				tabContentsSelectedFromContainer[i].classList.add('tab-content-active');
			} else {
				deactivateTab(singleTabSelected);
				tabContentsSelectedFromContainer[i].classList.remove('tab-content-active');
			}

		});
	}

	function activateTab(element) {
		element.classList.add('active-tab-selector');
		element.setAttribute('tabindex', 0);
		element.setAttribute('aria-pressed', 'true');
	}

	function deactivateTab(element) {
		element.classList.remove('active-tab-selector');
		element.setAttribute('tabindex', -1);
		element.setAttribute('aria-pressed', 'false');
	}

};